/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/Fandango.eventQueue.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'Fandango/eventQueue', exports: {} }; const exports = module.exports;

const EventNames = Object.freeze({
  LOCATION_OVERLAY_CLOSE: 'locOverlayClose',
  LOCATION_DROPDOWN_CLOSE: 'locDropdownClose',
})

const allowedNames = Object.keys(EventNames).map(key => EventNames[key])

const Messages = {
  EVENT_NAME_MISSING: 'Attempt to use an undefined Event Name:',
  INVALID_HANDLER: 'Handler must be a function:'
}

let events = {}

function addListener(eventName, eventHandler) {
  if (allowedNames.indexOf(eventName) === -1) {
    throw new Error(`(${module.name}) ${Messages.EVENT_NAME_MISSING} "${eventName}"`);
  }

  if (typeof eventHandler !== 'function') {
    throw new Error(`(${module.name}) ${Messages.INVALID_HANDLER} "${eventName}"`);
  }

  if (!events.hasOwnProperty.call(events, eventName)) {
    events[eventName] = [];
  }

  const index = events[eventName].push(eventHandler) - 1;

  return {
    remove() {
      delete events[eventName][index];
    }
  };
}

function emitEvent(eventName, payload) {
  if (allowedNames.indexOf(eventName) === -1) {
    throw new Error(`(${module.name}) ${Messages.EVENT_NAME_MISSING} "${eventName}"`);
  }

  if (!events.hasOwnProperty.call(events, eventName)) {
    return;
  }

  events[eventName].forEach(handler => handler(payload));
}

function resetQueue() {
  events = {};
}

function getQueue() {
  return events;
}

export default {
  __test__: {
    resetQueue,
    getQueue
  },
  on: addListener,
  emit: emitEvent,
  EventNames
};
